import { VISIME_UI_LANGUAGE_KEY, VISIME_LANGUAGE_CHANGED } from '../config/apiLanguage';

export function readLangFromSearchParams(search: string): 'en' | 'de' | null {
  const q = new URLSearchParams(search).get('lang');
  if (q === 'en' || q === 'de') return q;
  return null;
}

export function applyLangFromUrl(search: string): void {
  const lang = readLangFromSearchParams(search);
  if (!lang || typeof window === 'undefined') return;
  const current = localStorage.getItem(VISIME_UI_LANGUAGE_KEY);
  if (current === lang) return;
  localStorage.setItem(VISIME_UI_LANGUAGE_KEY, lang);
  window.dispatchEvent(new Event(VISIME_LANGUAGE_CHANGED));
}

export function replaceLangInUrl(lang: 'en' | 'de'): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  params.set('lang', lang);
  const qs = params.toString();
  const next = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  window.history.replaceState(null, '', next);
}
